import { defaultConverter } from 'lit';
import { timestampToDate } from './utils.js';

const { fromAttribute, toAttribute } = defaultConverter;

// eslint-disable-next-line no-unused-vars
function isInvalidDate(date) {
  return date.toString() === 'Invalid Date';
}

function prepareRailsDateString(str) {
  // 2024-01-00 00:00:00 +0000
  let result = str.replace(
    /^(\d{4}-\d{2}-\d{2}) (\d{2}:\d{2}:\d{2}) ([+-])(\d{2})(\d{2})$/,
    '$1T$2$3$4:$5'
  );

  // 2024-01-01 00:00:00
  result = result.replace(/(\d{4}-\d{2}-\d{2}) (\d{2}:\d{2}:\d{2})/, '$1T$2');

  return result;
}

function parseDateString(value) {
  if (!value) return value;

  const newValue = prepareRailsDateString(value);
  return new Date(newValue);
}

export function autoParseDate(value) {
  return Number(value) ? timestampToDate(value) : parseDateString(value);
}

export function typeCastValue(value, type) {
  switch (type) {
    case Boolean:
      if (value instanceof Boolean) {
        return value;
      }

      return value === 'false' ? null : value;
    case Date:
      if (value instanceof Date) {
        return value;
      }

      return autoParseDate(value);
    case Object:
      if (value instanceof Object) {
        return value;
      }

      return value ? JSON.parse(value) : undefined;
    case Array:
      if (value instanceof Array) {
        return value;
      }

      return value ? JSON.parse(value) : undefined;
    case Set:
      if (value instanceof Set) {
        return value;
      }

      if (value instanceof Array) {
        return new Set(value);
      }

      return value ? new Set(JSON.parse(value)) : undefined;
    default:
      return value;
  }
}

function newFromAttribute(value, type) {
  switch (type) {
    case Boolean:
      return value === 'false' ? null : value;
    case Date:
      return autoParseDate(value);
    default:
      return value;
  }
}

function newToAttribute(value, type) {
  switch (type) {
    // case Boolean:
    //   return "xxxx"; // example
    default:
      return value;
  }
}

// https://github.com/lit/lit-element/blob/master/src/lib/updating-element.ts#L145
const CustomConverter = {
  fromAttribute: function customFromAttribute(inputValue, type) {
    const value = newFromAttribute(inputValue, type);

    return fromAttribute(value, type);
  },

  toAttribute: function customToAttribute(inputValue, type) {
    const value = newToAttribute(inputValue, type);

    return toAttribute(value, type);
  },
};

export default CustomConverter;
